const UsageIdentifierFlow = {
    ADVERTISER: "ADVERTISER",
    AD_ACCOUNT: "AD_ACCOUNT"
};

const IdsType = {
    ADVERTISER: "ADVERTISERS",
    AD_ACCOUNTS: "AD_ACCOUNTS"
};

/**
 * Extracts unique, untracked IDs from the given list and updates localStorage state.
 *
 * @param {string[]} ids - Array of IDs to track (adAccountId or catalogId)
 * @param {string[]} [trackedIds=[]] - Already tracked IDs from localStorage
 * @returns {{ newIds: string[], updatedIds: string[] }}
 */
const extractAndUpdateTrackedIds = (ids, trackedIds = []) => {
    const uniqueIds = Array.from(new Set(ids));
    const newIds = uniqueIds.filter((id) => !trackedIds.includes(id));
    const updatedIds = [...trackedIds, ...newIds];

    return { newIds, updatedIds };
};

/**
 * Creates the payload and updated user object to be stored in localStorage
 * for tracking usage (advertiser or ad_account) without duplication.
 *
 * @param {string[]} ids - IDs to track
 * @param {Object} localStorageUser - Current localStorage user data
 * @param {string} identifier - Either 'Advertiser' or 'Ad_Account'
 * @returns {{
 *   usageAPIPayload: { ids: string[], idsType: string },
 * 
 * }}
 */

const createPostTrackUsagePayload = (ids, localStorageUser, identifier) => {
    const isAdvertiser = identifier === UsageIdentifierFlow.ADVERTISER;
    const trackedIds = localStorageUser?.trackingIds || [];

    const { newIds, updatedIds } = extractAndUpdateTrackedIds(ids, trackedIds);

    const usageAPIPayload = {
        ids: newIds,
        idsType: isAdvertiser ? IdsType.ADVERTISER : IdsType.AD_ACCOUNTS,
    };

    const updatedLocalStorageUserValue = {
        ...localStorageUser,
        trackingIds: updatedIds,
    };

    return {
        usageAPIPayload,
        updatedLocalStorageUserValue,
    };
};

const mapBusinessAccountData = (accounts) =>{
  let res = [];
  let options = [];
   accounts?.forEach((data)=>{
    options.push({
      label: data.businessId,
      value: data.businessId
    })
      res.push({
        businessId: data?.businessId,
        businessName: data?.businessName,
        lastUpdated: new Date(data?.lastSyndicatedAt).toLocaleString()
      })
   })

   return {res, options}
}


export { createPostTrackUsagePayload, UsageIdentifierFlow, IdsType, mapBusinessAccountData };
